(() => {
  function init(root = document) {
    root.querySelectorAll('[data-kap-share]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', async () => {
        const status = button.parentElement.querySelector('[data-kap-share-status]');
        try { await navigator.clipboard.writeText(button.dataset.url); status.textContent = button.dataset.copied; }
        catch { status.textContent = button.dataset.url; }
      });
    });
    root.querySelectorAll('[data-kap-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('.kap-gallery-track');
      const links = [...gallery.querySelectorAll('[data-kap-index]')];
      links.forEach((link, index) => link.addEventListener('click', event => {
        event.preventDefault();
        track.scrollTo({left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const current = Math.round(track.scrollLeft / track.clientWidth);
          links.forEach((link, i) => i === current ? link.setAttribute('aria-current', 'true') : link.removeAttribute('aria-current'));
        });
      }, {passive: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
